import { SIZE_THUMBNAIL_OPTIONS } from '@/shared/model';

export const sizeThumbnailMenu = [
  SIZE_THUMBNAIL_OPTIONS.SMALL,
  SIZE_THUMBNAIL_OPTIONS.MEDIUM,
  SIZE_THUMBNAIL_OPTIONS.LARGE,
];

export const thumbnailChannelList = [
  {
    label: 'CH1',
    value: 1,
  },
  {
    label: 'CH2',
    value: 2,
  },
  {
    label: 'CH3',
    value: 3,
  },
  {
    label: 'AI✨',
    value: 4,
  },
];
